import { getCachedEdgeworthDb, getTopCachedData, initEdgeworthDb, preloadUserIdStorageKey } from '@office-start/edgeworth-service';
(function () {
    // initialize IDB and prefetch EW data
    if ('Proxy' in window && localStorage[preloadUserIdStorageKey]) {
        window.ewRcPuid = JSON.parse(localStorage[preloadUserIdStorageKey]);
        initEdgeworthDb(window.ewRcPuid, 'officehome', window.ewClientCacheServerOffset, function () {
            if (window.ng2EventService) {
                window.ng2EventService.broadcastEvent({
                    name: 'sessionExpired',
                    args: []
                });
            }
        });
        var start_1 = performance.now();
        window.ewRcIdb = getCachedEdgeworthDb();
        window.ewRcPreloadData = window.ewRcIdb.then(getTopCachedData);
        window.ewRcPreloadDuration = window.ewRcPreloadData.then(function (_) {
            if (typeof (start_1) === 'number') {
                return performance.now() - start_1;
            }
            return undefined;
        });
    }
})();
